import { ComponentStyleConfig } from "@chakra-ui/react";

export const RadioTheme: Partial<ComponentStyleConfig> = {
  baseStyle: {
    container: {
      pl: 2,
      py: 1,
      pr: 4,
      fontSize: "1rem",
      borderRadius: "1000px",
      whiteSpace: "nowrap",
    },
    control: {
      w: 5,
      h: 5,
      bg: "white",
      transition: "all 0.2s",
      outline: "none !important",
      boxShadow: "none !important",
      _checked: {
        bg: "brand.red.100",
        borderColor: "brand.red.100",
        _before: {
          bg: "none",
          w: 5,
          h: 5,
          borderRadius: 0,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundImage: "url('/svg/check-white.svg')",
        },
        _hover: {
          bg: "brand.red.110",
          borderColor: "brand.red.110",
        },
      },
      _disabled: {
        boxShadow: "none",
      },
    },
  },
  sizes: {
    sm: {
      label: {
        fontSize: "1rem",
      },
    },
  },
};
